angular.module('elfium').directive('dashboardFilter', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {
            filter: '='
        },
        controller: 'dashboardFilterController',
        templateUrl: elfiumUrlService.getTemplateUrl('dashboard', 'dashboardFilter')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardFilter.ts